// Action
const OPEN = 'report_modal/open';
const CLOSE = 'report_modal/close';
// Action Creator
export const open = () => {
    return {
        type: OPEN,
    };
};
export const close = () => {
    return {
        type: CLOSE,
    };
};
const initialState = {
    isOpened: false,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case OPEN: {
            return Object.assign(Object.assign({}, state), { isOpened: true });
        }
        case CLOSE: {
            return Object.assign(Object.assign({}, state), { isOpened: false });
        }
        default: {
            return state;
        }
    }
};
